(function () {
    'use strict';

    angular
        .module('virtualFairs')
        .controller('UniversityConnectShowScheduleController', UniversityConnectShowScheduleController);

    UniversityConnectShowScheduleController.$inject = ['$uibModalInstance', '$state', '$stateParams', 'user', 'VirtualFairService'];

    function UniversityConnectShowScheduleController($uibModalInstance, $state, $stateParams, user, VirtualFairService) {
        var vm = this;

        vm.schedule              = [];
        vm.getSchedule           = getSchedule;    
        vm.user                  = user;    
        vm.cancel                = cancel;
       
        activate();

        function activate() {            
            vm.getSchedule(vm.user.virtual_fair_id, vm.user.user_id, vm.user.user_type);
        }

        function getSchedule (virtual_fair_id, user_id, user_type) {
            VirtualFairService.getScheduleUniversityConnect(virtual_fair_id, user_id, user_type).then(function(response){
                vm.schedule = response.data;
                vm.schedule_owner_type = vm.user.user_type;
                vm.schedule_owner_name = vm.user.user_name;
                vm.schedule_owner_token = vm.user.user_token;
            }).catch(function(err) {
            });
        }

        function cancel() {
            $uibModalInstance.close();
        }
        
    }

})();